import React, { useMemo } from "react";
import { Helmet } from "react-helmet";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./components/Login.page";
import Signup from "./components/Signup.page";
import ForgotPswSendEmail from "./components/ForgotPswSendEmail.page";
import ResetPwd from "./components/ResetPwdNew.page";
import useFindUser from "./hooks/UseFindUser";
import { UserContext } from "./hooks/UserContext";
import PrivateRoute from "./PrivateRoute";
import DynamicPrivateRoutes from "./DynamicPrivateRoutes";
import { MsgProvider } from "./hooks/MsgProvider";
import ModalProvider from "./hooks/ModalProvider";
import "./styles/text-security/text-security-disc.css";
import "./Global.css";
import "./custom.css";
import { DirtyCheckProvider } from "./hooks/DirtyCheckProvider";
import ChangePwd from "components/userManagement/changePassword.page";
import Maintenance from "view/error/Maintenance.js";

const TITLE = "EHP Data Collaboration Laboratory Portal";

export default function App() {
	console.log(
		`%cCurrent version: ` + `v${process.env.VERSION}_${process.env.BUILD_TIME}`,
		"font-size: 18px;color: blue"
	);
	const { user, setUser, findUser, isLoading } = useFindUser();
	const userData = useMemo(() => {
		return { user, setUser, findUser, isLoading };
	}, [user, isLoading]);

	return (
		<React.Fragment>
			<Helmet>
				<title>{TITLE}</title>
			</Helmet>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<DirtyCheckProvider>
					<ModalProvider>
						<MsgProvider>
							<Router>
								{/* Fortify: Privacy.Sensitive=false */}
								<UserContext.Provider value={userData}>
									<Switch>
										<Route path="/login" component={Login} />
										<Route path="/signup" component={Signup} />
										<Route path="/forgotPswSendEmail" component={ForgotPswSendEmail} />
										<Route path="/resetPwdNew" component={ResetPwd} />
										<Route path="/change-pwd-first-login" component={ChangePwd} />
										<Route path="/maintenance" component={Maintenance} />
										<PrivateRoute>
											<DynamicPrivateRoutes />
										</PrivateRoute>
									</Switch>
								</UserContext.Provider>
							</Router>
						</MsgProvider>
					</ModalProvider>
				</DirtyCheckProvider>
			</LocalizationProvider>
		</React.Fragment>
	);
}
